import { Directive, ElementRef, HostListener, Renderer2 } from "@angular/core";
import { AppConstants } from "../constants/constants";

@Directive({
  selector: "[appResizableColumn]",
})
export class ResizableColumnDirective {
  private startX: number = 0;
  private startWidth: number = 0;
  private resizable: HTMLElement | null = null;
  private resized: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener(AppConstants.MOUSE_DOWN, [AppConstants.EVENT_PROP])
  onMouseDown(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (target && target.classList.contains(AppConstants.RESIZE_HANDLE)) {
      event.preventDefault();

      this.resizable = this.el.nativeElement;
      this.startX = event.pageX;
      this.startWidth = this.resizable.offsetWidth;
      this.resized = false;

      document.addEventListener(
        AppConstants.MOUSE_MOVE,
        this.onMouseMoveResize
      );
      document.addEventListener(AppConstants.MOUSE_UP, this.onMouseUpResize);
    }
  }

  private onMouseMoveResize = (event: MouseEvent) => {
    if (!this.resizable) return;

    const parent = this.resizable.parentElement;
    if (!parent) return;

    const parentWidth = parent.clientWidth;
    const diffX = event.pageX - this.startX;
    let newWidth = ((this.startWidth + diffX) / parentWidth) * 100;

    newWidth = Math.max(newWidth, (50 / parentWidth) * 100);

    this.renderer.setStyle(
      this.resizable,
      AppConstants.WIDTH,
      `${newWidth}${AppConstants.PERCENT}`
    );
    this.resized = true;
  };

  private onMouseUpResize = (event: MouseEvent) => {
    event.preventDefault();

    document.removeEventListener(
      AppConstants.MOUSE_MOVE,
      this.onMouseMoveResize
    );
    document.removeEventListener(AppConstants.MOUSE_UP, this.onMouseUpResize);
    this.resizable = null;

    setTimeout(() => {
      this.resized = false;
    }, 100);
  };

  @HostListener(AppConstants.CLICK, [AppConstants.EVENT_PROP])
  onClick(event: MouseEvent) {
    if (this.resized) {
      event.stopImmediatePropagation();
    }
  }
}
